export default __webpack_public_path__ + "static/cv-lucca-ed10cf13b3060c3b8bd9da6508d41c2f.pdf";